define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/comm/PostRequest",
	"csi/breadcrumb/ReviseReopenController",
	"csi/config",
	"csi/locale",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,lang,PostRequest,ReviseReopenController,config,locale,MessageDialog,xml) {

	return declare(ReviseReopenController, {
		keepFrozenSectionsUnlinked: false,

		hasToConfirmAction: function() {
			const subtype = this.getParent().Subtype; 
			const bPromptToRelinkSharedSections = xml.isValidURL(subtype) && config.getSubtypeSetting(subtype, "PromptToRelinkSharedSections");
			if (bPromptToRelinkSharedSections) {
			    var frozenSections = this.getNode().FrozenSections;
			    var hasSectionsToRelink = frozenSections != null && frozenSections.length > 0;
			    this.keepFrozenSectionsUnlinked = false;
			    return this.inherited(arguments) || hasSectionsToRelink;
			} else {
			    return false;
			}

		},

		confirmAction: function(params) {
			params = params || {};
			params.title = this.m_action.m_name;
			params.message = locale.typeAction("SpecificationDataSheetRevision", "ReopenPhaseAction_Confirm");
			params.buttons = [MessageDialog.BUTTON_YES, MessageDialog.BUTTON_NO];
			this.inherited(arguments);
		},

		onConfirm: function(/*String*/key) {
			this.keepFrozenSectionsUnlinked = (key == MessageDialog.BUTTON_NO);
			this.inherited(arguments);
		},
		toWriter: function() {
			this.m_writer.callMethod("SpecificationDataSheet", "SpecificationDataSheetRevisionReopen")
				.addParameter(xml.PROP_URL, xml.ATTR_REF, this.m_urlNode)
				.addParameter("KeepFrozenSectionsUnlinked", xml.ATTR_BOOLEAN, this.keepFrozenSectionsUnlinked);
		}
	});
});
